'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { NavigationStore } from './navigation'
import {
  createNavigationActions,
  createUseExpandedItems,
  createUseNavigationPath,
  createUseOpenAccordions,
  defaultValues,
  initUrlSync as initUrlSyncBase,
  selectExpandedItemsString,
  selectOpenAccordionsString,
  selectPathString,
} from './navigation'

// ============================================================================
// Store
// ============================================================================

export const useNavigationStore = create<NavigationStore>()(
  devtools(
    (set, get) => ({
      ...defaultValues,
      ...createNavigationActions(set, get),
    }),
    { name: 'NavigationStore' }
  )
)

// ============================================================================
// URL Sync Initialization
// ============================================================================

export const initUrlSync = () => initUrlSyncBase(useNavigationStore)

// ============================================================================
// Selectors (re-exported for convenience)
// ============================================================================

export { selectExpandedItemsString, selectOpenAccordionsString, selectPathString }

// ============================================================================
// Custom Hooks
// ============================================================================

/**
 * Hook to get current navigation path
 * Uses string comparison internally for reliable change detection
 */
export const useNavigationPath = createUseNavigationPath(useNavigationStore)

/**
 * Hook to get expanded tree items
 * Uses string comparison internally for reliable change detection
 */
export const useExpandedItems = createUseExpandedItems(useNavigationStore)

/**
 * Hook to get open accordions
 * Uses string comparison internally for reliable change detection
 */
export const useOpenAccordions = createUseOpenAccordions(useNavigationStore)

// Re-export types
export type { NavigationStore }
